var _defs, _g, _g2, _g3, _g4, _g5, _g6;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPeopleMobileVd(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 4605.88 8215.66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:red;}.cls-1,.cls-2{opacity:.1;}.cls-2,.cls-3,.cls-4{fill:lime;}.cls-5{fill:#ccc;}.cls-6{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:5px;}.cls-4{opacity:.2;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "grey"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: -1384.32,
    y: 2194,
    width: 7396.09,
    height: 4584.31,
    transform: "translate(-2172.43 6799.88) rotate(-90)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "color"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1020.72 2376.38 1020.72 2413.37 21.57 2413.37 21.57 788.11 1572.85 788.11 1572.85 825.1 1610.34 822.84 1610.34 2376.38 1020.72 2376.38"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "grid"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 56.34,
    y1: 8184.2,
    x2: 56.33,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 93.32,
    y1: 8184.2,
    x2: 93.32,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 130.31,
    y1: 8184.2,
    x2: 130.31,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 167.3,
    y1: 8184.2,
    x2: 167.3,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 204.29,
    y1: 8184.2,
    x2: 204.28,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 241.28,
    y1: 8184.2,
    x2: 241.27,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 278.27,
    y1: 8184.2,
    x2: 278.26,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 315.25,
    y1: 8184.2,
    x2: 315.25,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 352.24,
    y1: 8184.2,
    x2: 352.24,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 389.23,
    y1: 8184.2,
    x2: 389.23,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 426.22,
    y1: 8184.2,
    x2: 426.21,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 463.21,
    y1: 8184.2,
    x2: 463.2,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 500.19,
    y1: 8184.2,
    x2: 500.19,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 537.18,
    y1: 8184.2,
    x2: 537.18,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 574.17,
    y1: 8184.2,
    x2: 574.17,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 611.16,
    y1: 8184.2,
    x2: 611.15,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 648.15,
    y1: 8184.2,
    x2: 648.14,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 685.13,
    y1: 8184.2,
    x2: 685.13,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 722.12,
    y1: 8184.2,
    x2: 722.12,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 759.11,
    y1: 8184.2,
    x2: 759.11,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 796.1,
    y1: 8184.2,
    x2: 796.1,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 833.09,
    y1: 8184.2,
    x2: 833.08,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 870.08,
    y1: 8184.2,
    x2: 870.07,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 907.06,
    y1: 8184.2,
    x2: 907.06,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 944.05,
    y1: 8184.2,
    x2: 944.05,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 981.04,
    y1: 8184.2,
    x2: 981.04,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1018.03,
    y1: 8184.2,
    x2: 1018.02,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1055.02,
    y1: 8184.2,
    x2: 1055.01,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1092,
    y1: 8184.2,
    x2: 1092,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1128.99,
    y1: 8184.2,
    x2: 1128.99,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1165.98,
    y1: 8184.2,
    x2: 1165.98,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1202.97,
    y1: 8184.2,
    x2: 1202.97,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1239.96,
    y1: 8184.2,
    x2: 1239.95,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1276.95,
    y1: 8184.2,
    x2: 1276.94,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1313.93,
    y1: 8184.2,
    x2: 1313.93,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1350.92,
    y1: 8184.2,
    x2: 1350.92,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1387.91,
    y1: 8184.2,
    x2: 1387.91,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1424.9,
    y1: 8184.2,
    x2: 1424.89,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1461.89,
    y1: 8184.2,
    x2: 1461.88,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1498.87,
    y1: 8184.2,
    x2: 1498.87,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1535.86,
    y1: 8184.2,
    x2: 1535.86,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1572.85,
    y1: 8184.2,
    x2: 1572.85,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1609.84,
    y1: 8184.2,
    x2: 1609.83,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1646.83,
    y1: 8184.2,
    x2: 1646.82,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1683.82,
    y1: 8184.2,
    x2: 1683.81,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1720.8,
    y1: 8184.2,
    x2: 1720.8,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1757.79,
    y1: 8184.2,
    x2: 1757.79,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1794.78,
    y1: 8184.2,
    x2: 1794.78,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1831.77,
    y1: 8184.2,
    x2: 1831.76,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1868.76,
    y1: 8184.2,
    x2: 1868.75,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1905.74,
    y1: 8184.2,
    x2: 1905.74,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1942.73,
    y1: 8184.2,
    x2: 1942.73,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1979.72,
    y1: 8184.2,
    x2: 1979.72,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 2016.71,
    y1: 8184.2,
    x2: 2016.7,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 2053.7,
    y1: 8184.2,
    x2: 2053.69,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 2090.69,
    y1: 8184.2,
    x2: 2090.68,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 2127.67,
    y1: 8184.2,
    x2: 2127.67,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 2164.66,
    y1: 8184.2,
    x2: 2164.66,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 2201.65,
    y1: 8184.2,
    x2: 2201.65,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 2238.64,
    y1: 8184.2,
    x2: 2238.63,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 2275.63,
    y1: 8184.2,
    x2: 2275.62,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 2312.61,
    y1: 8184.2,
    x2: 2312.61,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 2349.6,
    y1: 8184.2,
    x2: 2349.6,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 2386.59,
    y1: 8184.2,
    x2: 2386.59,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 2423.58,
    y1: 8184.2,
    x2: 2423.57,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 2460.57,
    y1: 8184.2,
    x2: 2460.56,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 2497.55,
    y1: 8184.2,
    x2: 2497.55,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 2534.54,
    y1: 8184.2,
    x2: 2534.54,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 2571.53,
    y1: 8184.2,
    x2: 2571.53,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 2608.52,
    y1: 8184.2,
    x2: 2608.52,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 2645.51,
    y1: 8184.2,
    x2: 2645.5,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 2682.5,
    y1: 8184.2,
    x2: 2682.49,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 2719.48,
    y1: 8184.2,
    x2: 2719.48,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 2756.47,
    y1: 8184.2,
    x2: 2756.47,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 2793.46,
    y1: 8184.2,
    x2: 2793.46,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 2830.45,
    y1: 8184.2,
    x2: 2830.44,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 2867.44,
    y1: 8184.2,
    x2: 2867.43,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 2904.42,
    y1: 8184.2,
    x2: 2904.42,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 2941.41,
    y1: 8184.2,
    x2: 2941.41,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 2978.4,
    y1: 8184.2,
    x2: 2978.4,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 3015.39,
    y1: 8184.2,
    x2: 3015.38,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 3052.38,
    y1: 8184.2,
    x2: 3052.37,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 3089.37,
    y1: 8184.2,
    x2: 3089.36,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 3126.35,
    y1: 8184.2,
    x2: 3126.35,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 3163.34,
    y1: 8184.2,
    x2: 3163.34,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 3200.33,
    y1: 8184.2,
    x2: 3200.33,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 3237.32,
    y1: 8184.2,
    x2: 3237.31,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 3274.31,
    y1: 8184.2,
    x2: 3274.3,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 3311.29,
    y1: 8184.2,
    x2: 3311.29,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 3348.28,
    y1: 8184.2,
    x2: 3348.28,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 3385.27,
    y1: 8184.2,
    x2: 3385.27,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 3422.26,
    y1: 8184.2,
    x2: 3422.25,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 3459.25,
    y1: 8184.2,
    x2: 3459.24,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 3496.24,
    y1: 8184.2,
    x2: 3496.23,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 3533.22,
    y1: 8184.2,
    x2: 3533.22,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 3570.21,
    y1: 8184.2,
    x2: 3570.21,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 3607.2,
    y1: 8184.2,
    x2: 3607.2,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 3644.19,
    y1: 8184.2,
    x2: 3644.18,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 3681.18,
    y1: 8184.19,
    x2: 3681.17,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 3718.16,
    y1: 8184.19,
    x2: 3718.16,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 3755.15,
    y1: 8184.19,
    x2: 3755.15,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 3792.14,
    y1: 8184.19,
    x2: 3792.14,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 3829.13,
    y1: 8184.19,
    x2: 3829.12,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 3866.12,
    y1: 8184.19,
    x2: 3866.11,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 3903.1,
    y1: 8184.19,
    x2: 3903.1,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 3940.09,
    y1: 8184.19,
    x2: 3940.09,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 3977.08,
    y1: 8184.19,
    x2: 3977.08,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 4014.07,
    y1: 8184.19,
    x2: 4014.07,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 4051.06,
    y1: 8184.19,
    x2: 4051.05,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 4088.05,
    y1: 8184.19,
    x2: 4088.04,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 4125.03,
    y1: 8184.19,
    x2: 4125.03,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 4162.02,
    y1: 8184.19,
    x2: 4162.02,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 4199.01,
    y1: 8184.19,
    x2: 4199.01,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 4236,
    y1: 8184.19,
    x2: 4235.99,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 4272.99,
    y1: 8184.19,
    x2: 4272.98,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 4309.97,
    y1: 8184.19,
    x2: 4309.97,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 4346.96,
    y1: 8184.19,
    x2: 4346.96,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 4383.95,
    y1: 8184.19,
    x2: 4383.95,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 4420.94,
    y1: 8184.19,
    x2: 4420.93,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 4457.93,
    y1: 8184.19,
    x2: 4457.92,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 4494.92,
    y1: 8184.19,
    x2: 4494.91,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 4531.9,
    y1: 8184.19,
    x2: 4531.9,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 4568.89,
    y1: 8184.19,
    x2: 4568.89,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 4605.88,
    y1: 8184.19,
    x2: 4605.88,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 3599.68,
    x2: 4605.88,
    y2: 3599.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 3636.67,
    x2: 4605.88,
    y2: 3636.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 3673.66,
    x2: 4605.88,
    y2: 3673.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 3710.65,
    x2: 4605.88,
    y2: 3710.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 3747.64,
    x2: 4605.88,
    y2: 3747.63
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 3784.63,
    x2: 4605.88,
    y2: 3784.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 3821.61,
    x2: 4605.88,
    y2: 3821.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 3858.6,
    x2: 4605.88,
    y2: 3858.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 3895.59,
    x2: 4605.88,
    y2: 3895.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 3932.58,
    x2: 4605.88,
    y2: 3932.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 3969.57,
    x2: 4605.88,
    y2: 3969.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 4006.55,
    x2: 4605.88,
    y2: 4006.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 4043.54,
    x2: 4605.88,
    y2: 4043.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 4080.53,
    x2: 4605.88,
    y2: 4080.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 4117.52,
    x2: 4605.88,
    y2: 4117.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 4154.51,
    x2: 4605.88,
    y2: 4154.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 4191.49,
    x2: 4605.88,
    y2: 4191.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 4228.48,
    x2: 4605.88,
    y2: 4228.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 4265.47,
    x2: 4605.88,
    y2: 4265.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 4302.46,
    x2: 4605.88,
    y2: 4302.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 4339.45,
    x2: 4605.88,
    y2: 4339.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 4376.44,
    x2: 4605.88,
    y2: 4376.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 4413.42,
    x2: 4605.88,
    y2: 4413.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 4450.41,
    x2: 4605.88,
    y2: 4450.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 4487.4,
    x2: 4605.88,
    y2: 4487.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 4524.39,
    x2: 4605.88,
    y2: 4524.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 4561.38,
    x2: 4605.88,
    y2: 4561.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 4598.36,
    x2: 4605.88,
    y2: 4598.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 4635.35,
    x2: 4605.88,
    y2: 4635.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 4672.34,
    x2: 4605.88,
    y2: 4672.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 4709.33,
    x2: 4605.88,
    y2: 4709.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 4746.32,
    x2: 4605.88,
    y2: 4746.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 4783.31,
    x2: 4605.88,
    y2: 4783.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 4820.29,
    x2: 4605.88,
    y2: 4820.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 4857.28,
    x2: 4605.88,
    y2: 4857.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 4894.27,
    x2: 4605.88,
    y2: 4894.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 4931.26,
    x2: 4605.88,
    y2: 4931.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 4968.25,
    x2: 4605.88,
    y2: 4968.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 5005.23,
    x2: 4605.88,
    y2: 5005.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 5042.22,
    x2: 4605.88,
    y2: 5042.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 5079.21,
    x2: 4605.88,
    y2: 5079.21
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 5116.2,
    x2: 4605.88,
    y2: 5116.19
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 5153.19,
    x2: 4605.88,
    y2: 5153.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 5190.18,
    x2: 4605.88,
    y2: 5190.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 5227.16,
    x2: 4605.88,
    y2: 5227.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 5264.15,
    x2: 4605.88,
    y2: 5264.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 5301.14,
    x2: 4605.88,
    y2: 5301.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 5338.13,
    x2: 4605.88,
    y2: 5338.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 5375.12,
    x2: 4605.88,
    y2: 5375.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 5412.1,
    x2: 4605.88,
    y2: 5412.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 5449.09,
    x2: 4605.88,
    y2: 5449.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 5486.08,
    x2: 4605.88,
    y2: 5486.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 5523.07,
    x2: 4605.88,
    y2: 5523.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 5560.06,
    x2: 4605.88,
    y2: 5560.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 5597.05,
    x2: 4605.88,
    y2: 5597.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 5634.03,
    x2: 4605.88,
    y2: 5634.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 5671.02,
    x2: 4605.88,
    y2: 5671.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 5708.01,
    x2: 4605.88,
    y2: 5708
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 5745,
    x2: 4605.88,
    y2: 5744.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 5781.99,
    x2: 4605.88,
    y2: 5781.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 5818.97,
    x2: 4605.88,
    y2: 5818.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 5855.96,
    x2: 4605.88,
    y2: 5855.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 5892.95,
    x2: 4605.88,
    y2: 5892.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 5929.94,
    x2: 4605.88,
    y2: 5929.93
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 5966.93,
    x2: 4605.88,
    y2: 5966.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 6003.91,
    x2: 4605.88,
    y2: 6003.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 6040.9,
    x2: 4605.88,
    y2: 6040.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 6077.89,
    x2: 4605.88,
    y2: 6077.89
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 6114.88,
    x2: 4605.88,
    y2: 6114.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 6151.87,
    x2: 4605.88,
    y2: 6151.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 6188.86,
    x2: 4605.88,
    y2: 6188.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 6225.84,
    x2: 4605.88,
    y2: 6225.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 6262.83,
    x2: 4605.88,
    y2: 6262.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 6299.82,
    x2: 4605.88,
    y2: 6299.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 6336.81,
    x2: 4605.88,
    y2: 6336.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 6373.8,
    x2: 4605.88,
    y2: 6373.79
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 6410.78,
    x2: 4605.88,
    y2: 6410.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 6447.77,
    x2: 4605.88,
    y2: 6447.77
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 6484.76,
    x2: 4605.88,
    y2: 6484.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 6521.75,
    x2: 4605.88,
    y2: 6521.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 6558.74,
    x2: 4605.88,
    y2: 6558.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 6595.73,
    x2: 4605.88,
    y2: 6595.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 6632.71,
    x2: 4605.88,
    y2: 6632.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 6669.7,
    x2: 4605.88,
    y2: 6669.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 6706.69,
    x2: 4605.88,
    y2: 6706.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 6743.68,
    x2: 4605.88,
    y2: 6743.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 6780.67,
    x2: 4605.88,
    y2: 6780.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 6817.65,
    x2: 4605.88,
    y2: 6817.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 6854.64,
    x2: 4605.88,
    y2: 6854.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 6891.63,
    x2: 4605.88,
    y2: 6891.63
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 6928.62,
    x2: 4605.88,
    y2: 6928.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 6965.61,
    x2: 4605.88,
    y2: 6965.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 7002.6,
    x2: 4605.88,
    y2: 7002.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 7039.58,
    x2: 4605.88,
    y2: 7039.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 7076.57,
    x2: 4605.88,
    y2: 7076.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 7113.56,
    x2: 4605.88,
    y2: 7113.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 7150.55,
    x2: 4605.88,
    y2: 7150.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 7187.54,
    x2: 4605.88,
    y2: 7187.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 7224.52,
    x2: 4605.88,
    y2: 7224.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 7261.51,
    x2: 4605.88,
    y2: 7261.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 7298.5,
    x2: 4605.88,
    y2: 7298.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 7335.49,
    x2: 4605.88,
    y2: 7335.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 7372.48,
    x2: 4605.88,
    y2: 7372.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 7409.46,
    x2: 4605.88,
    y2: 7409.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 7446.45,
    x2: 4605.88,
    y2: 7446.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 7483.44,
    x2: 4605.88,
    y2: 7483.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 7520.43,
    x2: 4605.88,
    y2: 7520.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 7557.42,
    x2: 4605.88,
    y2: 7557.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 7594.41,
    x2: 4605.88,
    y2: 7594.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 7631.39,
    x2: 4605.88,
    y2: 7631.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 7668.38,
    x2: 4605.88,
    y2: 7668.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 7705.37,
    x2: 4605.88,
    y2: 7705.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 7742.36,
    x2: 4605.88,
    y2: 7742.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 7779.35,
    x2: 4605.88,
    y2: 7779.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 7816.33,
    x2: 4605.88,
    y2: 7816.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 7853.32,
    x2: 4605.88,
    y2: 7853.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 7890.31,
    x2: 4605.88,
    y2: 7890.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 7927.3,
    x2: 4605.88,
    y2: 7927.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 7964.29,
    x2: 4605.88,
    y2: 7964.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 8001.28,
    x2: 4605.88,
    y2: 8001.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 8038.26,
    x2: 4605.88,
    y2: 8038.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 8075.25,
    x2: 4605.88,
    y2: 8075.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 8112.24,
    x2: 4605.88,
    y2: 8112.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 8149.23,
    x2: 4605.88,
    y2: 8149.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 788.11,
    x2: 4605.88,
    y2: 788.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 825.1,
    x2: 4605.88,
    y2: 825.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 862.09,
    x2: 4605.88,
    y2: 862.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 899.08,
    x2: 4605.88,
    y2: 899.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 936.07,
    x2: 4605.88,
    y2: 936.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 973.05,
    x2: 4605.88,
    y2: 973.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 1010.04,
    x2: 4605.88,
    y2: 1010.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 1047.03,
    x2: 4605.88,
    y2: 1047.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 1084.02,
    x2: 4605.88,
    y2: 1084.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 1121.01,
    x2: 4605.88,
    y2: 1121
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 1158,
    x2: 4605.88,
    y2: 1157.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 1194.98,
    x2: 4605.88,
    y2: 1194.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 1231.97,
    x2: 4605.88,
    y2: 1231.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 1268.96,
    x2: 4605.88,
    y2: 1268.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 1305.95,
    x2: 4605.88,
    y2: 1305.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 1342.94,
    x2: 4605.88,
    y2: 1342.93
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 1379.92,
    x2: 4605.88,
    y2: 1379.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 1416.91,
    x2: 4605.88,
    y2: 1416.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 1453.9,
    x2: 4605.88,
    y2: 1453.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 1490.89,
    x2: 4605.88,
    y2: 1490.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 1527.88,
    x2: 4605.88,
    y2: 1527.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 1564.86,
    x2: 4605.88,
    y2: 1564.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 1601.85,
    x2: 4605.88,
    y2: 1601.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 1638.84,
    x2: 4605.88,
    y2: 1638.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 1675.83,
    x2: 4605.88,
    y2: 1675.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 1712.82,
    x2: 4605.88,
    y2: 1712.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 1749.81,
    x2: 4605.88,
    y2: 1749.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 1786.79,
    x2: 4605.88,
    y2: 1786.79
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 1823.78,
    x2: 4605.88,
    y2: 1823.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 1860.77,
    x2: 4605.88,
    y2: 1860.77
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 1897.76,
    x2: 4605.88,
    y2: 1897.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 1934.75,
    x2: 4605.88,
    y2: 1934.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 1971.73,
    x2: 4605.88,
    y2: 1971.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 2008.72,
    x2: 4605.88,
    y2: 2008.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 2045.71,
    x2: 4605.88,
    y2: 2045.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 2082.7,
    x2: 4605.88,
    y2: 2082.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 2119.69,
    x2: 4605.88,
    y2: 2119.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 2156.68,
    x2: 4605.88,
    y2: 2156.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 2193.66,
    x2: 4605.88,
    y2: 2193.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 2230.65,
    x2: 4605.88,
    y2: 2230.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 2267.64,
    x2: 4605.88,
    y2: 2267.63
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 2304.63,
    x2: 4605.88,
    y2: 2304.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 2341.62,
    x2: 4605.88,
    y2: 2341.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 2378.6,
    x2: 4605.88,
    y2: 2378.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 2415.59,
    x2: 4605.88,
    y2: 2415.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 2452.58,
    x2: 4605.88,
    y2: 2452.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 2489.57,
    x2: 4605.88,
    y2: 2489.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 2526.56,
    x2: 4605.88,
    y2: 2526.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 2563.55,
    x2: 4605.88,
    y2: 2563.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 2600.53,
    x2: 4605.88,
    y2: 2600.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 2637.52,
    x2: 4605.88,
    y2: 2637.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 2674.51,
    x2: 4605.88,
    y2: 2674.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 2711.5,
    x2: 4605.88,
    y2: 2711.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 2748.49,
    x2: 4605.88,
    y2: 2748.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 2785.47,
    x2: 4605.88,
    y2: 2785.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 2822.46,
    x2: 4605.88,
    y2: 2822.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 2859.45,
    x2: 4605.88,
    y2: 2859.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 2896.44,
    x2: 4605.88,
    y2: 2896.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 2933.43,
    x2: 4605.88,
    y2: 2933.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 2970.42,
    x2: 4605.88,
    y2: 2970.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 3007.4,
    x2: 4605.88,
    y2: 3007.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 3044.39,
    x2: 4605.88,
    y2: 3044.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 3081.38,
    x2: 4605.88,
    y2: 3081.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 3118.37,
    x2: 4605.88,
    y2: 3118.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 3155.36,
    x2: 4605.88,
    y2: 3155.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 3192.34,
    x2: 4605.88,
    y2: 3192.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 3229.33,
    x2: 4605.88,
    y2: 3229.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 3266.32,
    x2: 4605.88,
    y2: 3266.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 3303.31,
    x2: 4605.88,
    y2: 3303.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 3340.3,
    x2: 4605.88,
    y2: 3340.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 3377.28,
    x2: 4605.88,
    y2: 3377.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 3414.27,
    x2: 4605.88,
    y2: 3414.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 3451.26,
    x2: 4605.88,
    y2: 3451.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 3488.25,
    x2: 4605.88,
    y2: 3488.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 3525.24,
    x2: 4605.88,
    y2: 3525.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.57,
    y1: 3562.23,
    x2: 4605.88,
    y2: 3562.22
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "zoom"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1598.71 809.11 1877.3 624.54 2244.51 621.74 1607.99 822.42 1575.91 822.84 1598.71 809.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1877.3 253.93 1575.91 790.71 1575.91 822.84 1877.3 624.54 1877.3 253.93"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "color-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "2244.51 621.74 1878.86 621.74 1878.86 256.99 2207.52 256.99 2207.52 293.74 2244.51 293.74 2244.51 621.74"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 2244.51,
    y: 220.24,
    width: 36.75,
    height: 36.75,
    transform: "translate(2501.5 -2024.28) rotate(90)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "grid-2"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "2244.07 585.2 2209.08 585.2 2205.69 601.62"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 2244.06,
    y1: 289.29,
    x2: 1879.31,
    y2: 289.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 2244.06,
    y1: 326.28,
    x2: 1879.31,
    y2: 326.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 2244.06,
    y1: 363.27,
    x2: 1879.31,
    y2: 363.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 2244.06,
    y1: 400.26,
    x2: 1879.31,
    y2: 400.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 2244.06,
    y1: 437.25,
    x2: 1879.31,
    y2: 437.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 2244.06,
    y1: 474.24,
    x2: 1879.31,
    y2: 474.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 2244.06,
    y1: 511.22,
    x2: 1879.31,
    y2: 511.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 2244.06,
    y1: 548.21,
    x2: 1879.31,
    y2: 548.21
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 2244.06,
    y1: 585.2,
    x2: 1879.31,
    y2: 585.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 2207.31,
    y1: 256.54,
    x2: 2207.31,
    y2: 622.19
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 2170.33,
    y1: 622.19,
    x2: 2170.32,
    y2: 256.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 2133.34,
    y1: 622.19,
    x2: 2133.33,
    y2: 256.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 2096.35,
    y1: 622.19,
    x2: 2096.34,
    y2: 256.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 2059.36,
    y1: 622.19,
    x2: 2059.36,
    y2: 256.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 2022.37,
    y1: 622.19,
    x2: 2022.37,
    y2: 256.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1985.38,
    y1: 622.19,
    x2: 1985.38,
    y2: 256.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1948.4,
    y1: 622.19,
    x2: 1948.39,
    y2: 256.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1911.41,
    y1: 622.19,
    x2: 1911.4,
    y2: 256.54
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleMobileVd);
export default __webpack_public_path__ + "static/media/people-mobile-vd.ed5a65d35d253326749ff585438988aa.svg";
export { ForwardRef as ReactComponent };